import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiShield, FiHeart, FiFeather, FiGlobe } = FiIcons;

const badges = [
  { icon: FiFeather, title: "Utterly Soft", desc: "Premium organic textiles" },
  { icon: FiShield, title: "Purely Safe", desc: "Rigorously safety tested" },
  { icon: FiHeart, title: "Gentle Design", desc: "Crafted for comfort" },
  { icon: FiGlobe, title: "Conscious", desc: "Earth-friendly choices" },
];

const TrustBadges = () => {
  return (
    <section className="bg-luma-bg py-16 lg:py-24 border-y border-luma-sand/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
          {badges.map((badge, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm group-hover:shadow-md transition-shadow">
                <SafeIcon icon={badge.icon} className="text-2xl text-luma-primary" />
              </div>
              <h3 className="font-serif text-xl font-medium mb-2">{badge.title}</h3>
              <p className="text-[11px] uppercase tracking-widest text-luma-text/40 font-bold">{badge.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;